import { configureStore } from "@reduxjs/toolkit";
import merchantsReducer from "./features/merchant/merchantsSlice";

export const store = configureStore({
  reducer: {
    merchant: merchantsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
